import { Worker, CardReader } from '../types';

export const mockWorkers: Worker[] = [
  {
    id: 'worker-001',
    firstName: 'Mike',
    lastName: 'Thompson',
    email: 'mike.thompson@school.edu',
    phone: '(555) 123-4567',
    workerTypes: ['concession'],
    isActive: true,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: 'worker-002',
    firstName: 'Sarah',
    lastName: 'Martinez',
    email: 'sarah.martinez@school.edu',
    phone: '(555) 234-5678',
    workerTypes: ['concession', 'ticket'],
    assignedEventIds: [
      '850e8400-e29b-41d4-a716-446655440061-student',
      '850e8400-e29b-41d4-a716-446655440061-adult',
      '850e8400-e29b-41d4-a716-446655440061-senior',
    ],
    isActive: true,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: 'worker-003',
    firstName: 'Tom',
    lastName: 'Wilson',
    email: 'tom.wilson@school.edu',
    phone: '(555) 345-6789',
    workerTypes: ['ticket'],
    assignedEventIds: [
      '850e8400-e29b-41d4-a716-446655440061-student',
      '850e8400-e29b-41d4-a716-446655440061-adult',
      '850e8400-e29b-41d4-a716-446655440061-senior',
      '850e8400-e29b-41d4-a716-446655440062-student',
      '850e8400-e29b-41d4-a716-446655440062-adult',
      '850e8400-e29b-41d4-a716-446655440062-senior',
    ],
    isActive: true,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: 'worker-004',
    firstName: 'Linda',
    lastName: 'Garcia',
    email: 'linda.garcia@school.edu',
    phone: '(555) 456-7890',
    workerTypes: ['ticket'],
    assignedEventIds: [
      '850e8400-e29b-41d4-a716-446655440064-student',
      '850e8400-e29b-41d4-a716-446655440064-adult',
      '850e8400-e29b-41d4-a716-446655440064-senior',
      '850e8400-e29b-41d4-a716-446655440065-student',
      '850e8400-e29b-41d4-a716-446655440065-adult',
      '850e8400-e29b-41d4-a716-446655440065-senior',
    ],
    isActive: true,
    createdAt: new Date('2024-08-01'),
  },
  {
    id: 'worker-005',
    firstName: 'Chris',
    lastName: 'Johnson',
    email: 'chris.johnson@school.edu',
    phone: '(555) 567-8901',
    workerTypes: ['concession'],
    isActive: true,
    createdAt: new Date('2024-08-15'),
  },
];

export const mockCardReaders: CardReader[] = [
  {
    id: 'reader-001',
    name: 'Stripe Reader M2 - Concession Stand',
    type: 'bluetooth',
    status: 'connected',
    batteryLevel: 85,
    lastSeen: new Date(),
  },
  {
    id: 'reader-002',
    name: 'Stripe Reader S700 - Main Gate',
    type: 'wifi',
    status: 'connected',
    batteryLevel: 100,
    lastSeen: new Date(),
  },
  {
    id: 'reader-003',
    name: 'Stripe Reader M2 - South Entrance',
    type: 'bluetooth',
    status: 'disconnected',
    batteryLevel: 45,
    lastSeen: new Date(Date.now() - 3600000),
  },
  {
    id: 'reader-004',
    name: 'Stripe Reader BBPOS - Gym Entrance',
    type: 'bluetooth',
    status: 'pairing',
    batteryLevel: 72,
    lastSeen: new Date(),
  },
];

export const getActiveWorkers = () => mockWorkers.filter(w => w.isActive);

export const getWorkersByType = (type: 'concession' | 'ticket') =>
  mockWorkers.filter(w => w.isActive && w.workerTypes.includes(type));

export const getConnectedCardReaders = () =>
  mockCardReaders.filter(r => r.status === 'connected');

export const findWorkerByPhone = (phone: string): Worker | null => {
  const normalizedPhone = phone.replace(/\D/g, '');
  return mockWorkers.find(w => {
    const workerPhone = w.phone.replace(/\D/g, '');
    return w.isActive && (workerPhone === normalizedPhone || workerPhone.endsWith(normalizedPhone));
  }) || null;
};
